export default __webpack_public_path__ + "static/media/witnesses-2.2cb19b2d.jpg";